/*---------------------------------------------------------------
 ?? Project: Ring2All Platform
 ????? Author: Rodrigo Cuadra
 ?? Company: Ring2All LLC
 ?? File: components\VIPListGeneralBox.tsx
 ??? Created: 2026-05-02
 ?? Description:
    Implementation of the PBX Call Center module.
----------------------------------------------------------------*/


import { Crown } from 'lucide-react';
import { FormBox } from '../../../components/ui/FormBox';
import { Label } from '../../../components/ui/label';
import { Input } from '../../../components/ui/input';
import Toggle from '../../../components/ui/Toggle';
import SimpleTooltip from '../../../components/ui/SimpleTooltip';

interface VIPListGeneralBoxProps {
    name: string;
    enabled: boolean;
    onNameChange: (v: string) => void;
    onEnabledChange: (v: boolean) => void;
    t: (key: string) => string;
}

export function VIPListGeneralBox({ name, enabled, onNameChange, onEnabledChange, t }: VIPListGeneralBoxProps) {
    return (
        <FormBox title={t('vipLists.form.sections.general')} icon={<Crown className="h-5 w-5" />}>
            <div className="grid grid-cols-12 gap-3">
                {/* List Name */}
                <SimpleTooltip content={t('vipLists.form.fields.name.tooltip')} className="col-span-12 md:col-span-6 lg:col-span-3">
                    <Label htmlFor="name" className="text-left">
                        {t('vipLists.form.fields.name.label')}
                    </Label>
                </SimpleTooltip>
                <div className="col-span-12 md:col-span-6 lg:col-span-3">
                    <Input
                        id="name"
                        value={name}
                        onChange={(e) => onNameChange(e.target.value)}
                        placeholder={t('vipLists.form.fields.name.placeholder')}
                        required
                    />
                </div>

                {/* Enabled */}
                <div className="col-span-12 md:col-span-6 lg:col-span-3">
                    <SimpleTooltip content={t('vipLists.form.fields.enabled.tooltip')}>
                        <Label htmlFor="enabled" className="text-left">
                            {t('vipLists.form.fields.enabled.label')}
                        </Label>
                    </SimpleTooltip>
                </div>
                <div className="col-span-12 md:col-span-6 lg:col-span-3">
                    <Toggle
                        id="enabled"
                        value={enabled}
                        onChange={onEnabledChange}
                    />
                </div>
            </div>
        </FormBox>
    );
}
